import { BookingType } from '../../types';

export { BookingType };

/**
 * Until we can configure apollo-tooling to parse Time schema types as Dates
 */
export interface TimeSlot {
  start: string;
  end: string;
}

export enum BookingStage {
  DateSelect = 'dateSelect',
  Confirm = 'confirm',
}

export enum FieldValues {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  BookingType = 'bookingType',
  SelectedDate = 'selectedDate',
  SelectedSlot = 'selectedSlot',
  Stage = 'bookingStage',
  Range = 'range',
  Message = 'message',
}

export type Range = {
  from: Date;
  to: Date;
};

export interface FormValues {
  [FieldValues.BookingType]: BookingType;
  [FieldValues.SelectedDate]?: Date;
  [FieldValues.SelectedSlot]?: TimeSlot;
  [FieldValues.Stage]: BookingStage;
  [FieldValues.Range]: Range;
  [FieldValues.Message]?: string;
}

export interface SubmissionError {
  error: boolean;
  message: string;
}

export interface FormikStatus {
  submissionError?: SubmissionError;
  submissionComplete?: boolean;
}
